export const monoAlphBreakText = {
  "0": {
    "letter": "$",
    "freq": 9.062170706
  },
  "1": {
    "letter": "%",
    "freq": 9.062170706
  },
  "2": {
    "letter": "@",
    "freq": 8.956796628
  },
  "3": {
    "letter": "h",
    "freq": 6.6385669125
  },
  "4": {
    "letter": "a",
    "freq": 6.2170706006
  },
  "5": {
    "letter": "n",
    "freq": 5.9009483667
  },
  "6": {
    "letter": "i",
    "freq": 5.6902002107
  },
  "7": {
    "letter": "k",
    "freq": 4.320337197
  },
  "8": {
    "letter": "j",
    "freq": 4.2149631191
  },
  "9": {
    "letter": "z",
    "freq": 3.6880927292
  },
  "10": {
    "letter": "x",
    "freq": 3.2665964173
  },
  "11": {
    "letter": "m",
    "freq": 3.1612223393
  },
  "12": {
    "letter": "o",
    "freq": 2.9504741834
  },
  "13": {
    "letter": "g",
    "freq": 2.8451001054
  },
  "14": {
    "letter": "y",
    "freq": 2.8451001054
  },
  "15": {
    "letter": "^",
    "freq": 2.8451001054
  },
  "16": {
    "letter": "t",
    "freq": 2.7397260274
  },
  "17": {
    "letter": "v",
    "freq": 2.1074815595
  },
  "18": {
    "letter": "l",
    "freq": 1.7913593256
  },
  "19": {
    "letter": "&",
    "freq": 1.7913593256
  },
  "20": {
    "letter": "d",
    "freq": 1.5806111697
  },
  "21": {
    "letter": "w",
    "freq": 1.3698630137
  },
  "22": {
    "letter": "u",
    "freq": 1.3698630137
  },
  "23": {
    "letter": "c",
    "freq": 1.3698630137
  },
  "24": {
    "letter": "f",
    "freq": 0.9483667018
  },
  "25": {
    "letter": "q",
    "freq": 0.7376185458
  },
  "26": {
    "letter": "e",
    "freq": 0.7376185458
  },
  "27": {
    "letter": "r",
    "freq": 0.6322444679
  },
  "28": {
    "letter": "p",
    "freq": 0.5268703899
  },
  "29": {
    "letter": "#",
    "freq": 0.3161222339
  },
  "30": {
    "letter": "s",
    "freq": 0.210748156
  },
  "31": {
    "letter": "b",
    "freq": 0.105374078
  }
}

export const Chapter2Text = {
 '0': {'freq': 9.3523691289, 'letter': 'о'},
 '1': {'freq': 8.3385061039, 'letter': 'а'},
 '10': {'freq': 3.8692323609, 'letter': 'е'},
 '11': {'freq': 3.6623215394, 'letter': 'л'},
 '12': {'freq': 3.3312642251, 'letter': 'м'},
 '13': {'freq': 3.2484998965, 'letter': 'у'},
 '14': {'freq': 3.1036623215, 'letter': 'д'},
 '15': {'freq': 2.9381336644, 'letter': 'п'},
 '16': {'freq': 2.3174012001, 'letter': 'з'},
 '17': {'freq': 2.1311814608, 'letter': 'я'},
 '18': {'freq': 1.7173598179, 'letter': 'б'},
 '19': {'freq': 1.5932133251, 'letter': 'ш'},
 '2': {'freq': 7.8212290503, 'letter': 'и'},
 '20': {'freq': 1.3863025036, 'letter': 'ь'},
 '21': {'freq': 1.2207738465, 'letter': 'й'},
 '22': {'freq': 1.0966273536, 'letter': 'ч'},
 '23': {'freq': 1.0552451893, 'letter': 'г'},
 '24': {'freq': 0.9931719429, 'letter': 'ж'},
 '25': {'freq': 0.8897165322, 'letter': 'ф'},
 '26': {'freq': 0.86902545, 'letter': 'ц'},
 '27': {'freq': 0.86902545, 'letter': 'ю'},
 '28': {'freq': 0.7448789572, 'letter': 'ї'},
 '29': {'freq': 0.6000413822, 'letter': 'щ'},
 '3': {'freq': 6.0624870681, 'letter': 'н'},
 '30': {'freq': 0.5586592179, 'letter': 'є'},
 '31': {'freq': 0.5172770536, 'letter': 'х'},
 '4': {'freq': 5.7728119181, 'letter': 'т'},
 '5': {'freq': 5.5038278502, 'letter': 'і'},
 '6': {'freq': 4.8830953859, 'letter': 'в'},
 '7': {'freq': 4.6348024002, 'letter': 'р'},
 '8': {'freq': 4.469273743, 'letter': 'к'},
 '9': {'freq': 4.4485826609, 'letter': 'с'}}